<template>
  <nav v-if="isMobile" class="bfms-mobile-nav" :class="{ 'bfms-mobile-nav--keyboard': keyboardOpen }" :aria-label="label('Main navigation')">
    <router-link v-for="item in primaryItems" :key="item.path" :to="item.path" class="bfms-mobile-nav__item" :class="{ 'is-active': matches(item.path) }" :aria-current="matches(item.path) ? 'page' : undefined">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons[item.icon]" /></svg>
      <span>{{ label(item.short || item.label) }}</span>
    </router-link>
    <button ref="moreButton" type="button" class="bfms-mobile-nav__item" :class="{ 'is-active': menuOpen || !primaryItems.some(item => matches(item.path)) }" :aria-expanded="menuOpen" aria-controls="bfms-mobile-menu" aria-haspopup="dialog" @click="openMenu">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.more" /></svg>
      <span>{{ label('More') }}</span>
    </button>
  </nav>
  <teleport to="body">
    <div v-if="menuOpen && isMobile" class="bfms-mobile-menu-backdrop" @click.self="closeMenu" @keydown="onMenuKeydown">
      <section id="bfms-mobile-menu" ref="menu" class="bfms-mobile-menu" role="dialog" aria-modal="true" aria-labelledby="bfms-mobile-menu-title" tabindex="-1">
        <header class="bfms-mobile-menu__header">
          <div><span class="bfms-mobile-menu__eyebrow">BFMSCare</span><h2 id="bfms-mobile-menu-title">{{ label(portal === 'employee' ? 'Employee Portal' : 'Vendor Portal') }}</h2></div>
          <button ref="closeButton" type="button" class="bfms-mobile-menu__close" :aria-label="label('Close menu')" @click="closeMenu"><svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.close" /></svg></button>
        </header>
        <nav :aria-label="label('All portal pages')" class="bfms-mobile-menu__pages">
          <div v-for="group in menuGroups" :key="group.label" class="bfms-mobile-menu__group">
            <h3>{{ label(group.label) }}</h3>
            <router-link v-for="item in group.items" :key="item.path" :to="item.path" class="bfms-mobile-menu__link" :class="{ 'is-active': matches(item.path) }" :aria-current="matches(item.path) ? 'page' : undefined" @click="closeMenu">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons[item.icon]" /></svg><span>{{ label(item.label) }}</span><span class="bfms-mobile-menu__chevron" aria-hidden="true">›</span>
            </router-link>
          </div>
          <button type="button" class="bfms-mobile-menu__link" @click="openDisplayOptions"><svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.display" /></svg><span>{{ label('Display options') }}</span></button>
          <button type="button" class="bfms-mobile-menu__link bfms-mobile-menu__signout" @click="signOut"><svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.logout" /></svg><span>{{ label('Sign Out') }}</span></button>
        </nav>
      </section>
    </div>
  </teleport>
</template>

<script>
import Swal from 'sweetalert2';

const icons = {
  home: 'M3 10.5 12 3l9 7.5M5 9v12h5v-7h4v7h5V9',
  time: 'M12 8v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0',
  invoice: 'M6 3h12v18l-3-2-3 2-3-2-3 2V3Zm3 5h6m-6 4h6m-6 4h3',
  payroll: 'M3 6h18v14H3V6Zm0 4h18M6 16h4',
  files: 'M3 7V4h7l2 3h9v13H3V7Zm0 3h18',
  message: 'M3 5h18v14H3V5Zm0 1 9 7 9-7',
  enrollment: 'M6 4h12v17H6V4Zm3 0V2h6v2M9 9h6m-6 4h6m-6 4h3',
  profile: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M4 21v-2a8 8 0 0 1 16 0v2',
  signature: 'm4 17 9-9 3 3-9 9H4v-3Zm9-9 3-3 3 3-3 3M3 22h18',
  lock: 'M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5V10Zm7 4v3',
  clients: 'M5 7h14m-4-4 4 4-4 4M19 17H5m4-4-4 4 4 4',
  logout: 'M10 3H3v18h7m4-15 6 6-6 6m-7-6h13',
  more: 'M5 11h.01M12 11h.01M19 11h.01M6 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0',
  close: 'm6 6 12 12M6 18 18 6',
  display: 'M4 4h16v12H4V4Zm4 16h8m-4-4v4M8 8h8m-8 4h4',
};
const employee = [
  { path: '/dashboard', label: 'Dashboard', short: 'Home', icon: 'home' },
  { path: '/TimeSheet', label: 'Time Sheet', short: 'Time', icon: 'time' },
  { path: '/invoice-sheets', label: 'Invoice Sheets', short: 'Invoices', icon: 'invoice' },
  { path: '/payroll', label: 'Payroll', icon: 'payroll' },
];
const vendor = [
  { path: '/dashboard', label: 'Dashboard', short: 'Home', icon: 'home' },
  { path: '/Invoice', label: 'Invoice Sheets', short: 'Invoices', icon: 'invoice' },
  { path: '/vendor_form', label: 'Files', icon: 'files' },
  { path: '/Message', label: 'Message Center', short: 'Messages', icon: 'message' },
];

export default {
  name: 'MobileNavigation',
  props: { portal: { type: String, required: true, validator: value => ['employee', 'vendor'].includes(value) } },
  data: () => ({ icons, isMobile: false, menuOpen: false, keyboardOpen: false, previousFocus: null, previousOverflow: '' }),
  computed: {
    primaryItems() { return this.portal === 'employee' ? employee : vendor; },
    menuGroups() {
      if (this.portal === 'employee') return [
        { label: 'Work', items: [employee[0], { path: '/enrollment', label: 'Enrollment', icon: 'enrollment' }, ...employee.slice(1), { path: '/Message', label: 'Message Center', icon: 'message' }] },
        { label: 'Account', items: [{ path: '/swith_client', label: 'Switch Client', icon: 'clients' }, { path: '/change_password', label: 'Change Password', icon: 'lock' }] },
      ];
      return [
        { label: 'Work', items: [vendor[0], vendor[1], { path: '/enrollment', label: 'Enrollment', icon: 'enrollment' }, vendor[2], vendor[3]] },
        { label: 'Account', items: [{ path: '/profile', label: 'Account Information', icon: 'profile' }, { path: '/paymentdetails', label: 'Banking Information', icon: 'payroll' }, { path: '/payroll-rates', label: 'Payroll & Rates', icon: 'payroll' }, { path: '/signature', label: 'Signature', icon: 'signature' }, { path: '/change_password', label: 'Change Password', icon: 'lock' }] },
      ];
    },
  },
  watch: { '$route.fullPath'() { this.closeMenu(); } },
  mounted() {
    this.media = window.matchMedia('(max-width: 767px)');
    this.onViewportChange = () => { this.isMobile = this.media.matches; if (!this.isMobile) this.closeMenu(); this.updateKeyboard(); };
    this.onViewportChange();
    if (this.media.addEventListener) this.media.addEventListener('change', this.onViewportChange);
    else this.media.addListener(this.onViewportChange);
    this.onKeyboardChange = () => this.updateKeyboard();
    if (window.visualViewport) window.visualViewport.addEventListener('resize', this.onKeyboardChange);
    document.addEventListener('focusin', this.onKeyboardChange);
    document.addEventListener('focusout', this.onKeyboardChange);
  },
  beforeUnmount() {
    this.closeMenu(false);
    if (this.media) {
      if (this.media.removeEventListener) this.media.removeEventListener('change', this.onViewportChange);
      else this.media.removeListener(this.onViewportChange);
    }
    if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.onKeyboardChange);
    document.removeEventListener('focusin', this.onKeyboardChange);
    document.removeEventListener('focusout', this.onKeyboardChange);
  },
  methods: {
    label(text) { return typeof this.$t === 'function' ? this.$t(text) : text; },
    matches(path) { return this.$route.path.toLowerCase() === path.toLowerCase(); },
    updateKeyboard() {
      const active = document.activeElement;
      const editing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
      this.keyboardOpen = Boolean(editing && window.visualViewport && window.innerHeight - window.visualViewport.height > 140);
    },
    openMenu() {
      if (this.menuOpen) return;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.menuOpen = true;
      this.$nextTick(() => this.$refs.closeButton?.focus());
    },
    closeMenu(restoreFocus = true) {
      if (!this.menuOpen) return;
      this.menuOpen = false;
      document.body.style.overflow = this.previousOverflow;
      if (restoreFocus) this.$nextTick(() => { if (this.previousFocus?.isConnected) this.previousFocus.focus(); });
    },
    onMenuKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); this.closeMenu(); return; }
      if (event.key !== 'Tab') return;
      const items = this.$refs.menu?.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]');
      if (!items?.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    },
    openDisplayOptions() {
      this.closeMenu(false);
      this.$store.commit('toggleConfigurator');
    },
    async signOut() {
      this.closeMenu(false);
      const result = await Swal.fire({ title: 'Are you sure?', text: 'You will be signed out!', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, sign me out!' });
      if (!result.isConfirmed) return;
      localStorage.removeItem('token');
      if (this.portal === 'employee') for (const key of ['selectedClientId', 'clientName', 'clientLastName']) localStorage.removeItem(key);
      this.$router.push({ name: 'Sign In' });
    },
  },
};
</script>
